import React, { Dispatch, createContext, useState } from "react";

export const AppContext = createContext<{
  mobileMenuOpen: boolean;
  setMobileMenuOpen: Dispatch<boolean>;
  switchOrganizationDialogIsOpen: boolean;
  setSwitchOrganizationDialogIsOpen: Dispatch<boolean>;
}>({
  mobileMenuOpen: false,
  setMobileMenuOpen: () => {},
  switchOrganizationDialogIsOpen: false,
  setSwitchOrganizationDialogIsOpen: () => {},
});

export function AppContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [switchOrganizationDialogIsOpen, setSwitchOrganizationDialogIsOpen] =
    useState(false);

  return (
    <AppContext.Provider
      value={{
        mobileMenuOpen,
        setMobileMenuOpen,
        switchOrganizationDialogIsOpen,
        setSwitchOrganizationDialogIsOpen,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}
